// fetchReferralRedeemStatus.js
'use strict';

import getMeData from '../selector/getMeData.js';
import fetch from '../resource/customFetch.js';
import getResourceUrl from '../resource/getResourceUrl.js';
import { getHeaders } from '../resource/fetchOptionHeader.js';
import handleFetchError from '../resource/handleFetchError.js';

import {
  MERGE_ME_DATA,
  SET_NETWORKING_FETCHING,
  SET_NETWORKING_SUCCESS,
  SET_NETWORKING_ERROR,
} from '../ActionTypes.js';

/**
 * Fetch referral redeem status
 * @kind action
 * @return {Promise} Action promise.
 */
const fetchReferralRedeemStatus = () => async (dispatch, getState) => {
  const selectPath = ['me', 'referral', 'redeemStatus'];
  const token = getMeData(getState(), 'token');

  const fetchOptions = {
    method: 'GET',
    headers: {
      ...getHeaders(),
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  const fetchUrl = getResourceUrl({ endpoint: '/me/referral_redeem_status' });

  dispatch({ type: SET_NETWORKING_FETCHING, payload: { selectPath } });
  try {
    let response = await fetch(fetchUrl.href, fetchOptions);

    if (!response.ok) {
      response = await handleFetchError({
        response,
        dispatch,
        getState,
        fetchOptions,
        fetchUrl,
      });
    }

    const payload = await response.json();

    // Set default values if payload.reward is null or undefined
    const referrerReward = payload.reward?.referrer || { type: '', value: 0 };
    const referralReward = payload.reward?.referral || { type: '', value: 0 };

    // Handle rewarded being null (convert to boolean)
    const rewarded = payload.rewarded === true;

    // Create payload with both paths for data
    const mergePayload = {
      referral: {
        // Save to redeemStatus path for the feature functionality
        redeemStatus: {
          rewarded: rewarded,
          redeemedAt: payload.redeemed_at,
          reward: {
            referrer: {
              type: referrerReward.type,
              value: referrerReward.value,
            },
            referral: {
              type: referralReward.type,
              value: referralReward.value,
            },
          },
        },
      },
    };

    dispatch({
      type: MERGE_ME_DATA,
      payload: mergePayload,
    });

    return dispatch({ type: SET_NETWORKING_SUCCESS, payload: { selectPath } });
  } catch (error) {
    return dispatch({
      type: SET_NETWORKING_ERROR,
      payload: { selectPath, error },
    });
  }
};

export default fetchReferralRedeemStatus;
